import { render } from "./FilteringBuild.vue?vue&type=template&id=4f361532&ts=true"
import script from "./FilteringBuild.vue?vue&type=script&lang=ts"
export * from "./FilteringBuild.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__